/**
 * The single row cap shared by every "first N rows of a table" entry point:
 * the Object Explorer's "Select top N rows" context-menu action (via the
 * per-engine script providers), and the Query Editor's "Query a table" seed
 * (`buildTableSeedSql`). One constant so the two paths never disagree — bump
 * it here, and every label and generated statement follows.
 */
export const SELECT_TOP_ROW_LIMIT = 1000;
